// extracted by mini-css-extract-plugin
module.exports = {"originalPrice":"price-module--originalPrice--2TAJZ"};